
import automation from '../../../assets/images/gallery/automation.jpg';
import automotive from '../../../assets/images/gallery/automotive.jpg';
import bike from '../../../assets/images/gallery/bike.jpg';
import rover from '../../../assets/images/gallery/rover.jpeg';
import gas from '../../../assets/images/gallery/gas.jpg';
import plane from '../../../assets/images/gallery/plane.jpg';

export const images = [
  gas,
  rover,
  automotive,
  plane,
  automation,
  bike,
];

export const data = [
  'Automotive',
  'Consumer Goods',
  'Rail & Weigh',
  'Injection Molding',
  'Food & Beverage',
  'Medical Devices',
  'Aerospace',
  'Military',
  'Oil & Gas',
  'Automation & Robotics',
  'Manufacturing',
  '& More...',
];